import { GenericFormItem } from 'skyone-lib/lib/GenericForm/interfaces';

export const passwordFields: GenericFormItem[] = [
  {
    gridXs: 10,
    label: 'MINIMUM_PASSWORD_LENGTH_KEY',
    stateKey: 'min_length',
    type: 'number',
    validateOnChange: true,
  },
  {
    gridXs: 12,
    label: 'REQUIRE_UPPERCASE_KEY',
    stateKey: 'require_upper',
    isRadioGroup: true,
    disabled: true,
  },
  {
    gridXs: 12,
    label: 'REQUIRE_LOWERCASE_KEY',
    stateKey: 'require_lower',
    isRadioGroup: true,
    disabled: true,
  },
  {
    gridXs: 12,
    label: 'REQUIRE_NUMBER_KEY',
    stateKey: 'require_num',
    isRadioGroup: true,
    disabled: true,
  },
  {
    gridXs: 12,
    label: 'REQUIRE_SPECIAL_CHARACTER_KEY',
    stateKey: 'require_symbol',
    isRadioGroup: true,
    disabled: true,
  },
  {
    gridXs: 12,
    label: 'EXPIRATION_PASSWORD_KEY',
    stateKey: 'expire_passwords',
    isCheckbox: true,
  },
  {
    gridXs: 7,
    label: 'EXPIRATION_PASSWORD_DAYS_KEY',
    stateKey: 'expire_days',
    type: 'number',
  },
  {
    gridXs: 10,
    label: 'NUMBER_MAX_LOGIN_TRIES_KEY',
    stateKey: 'max_auth_tries',
    type: 'number',
    validateOnChange: true,
  },
  {
    gridXs: 10,
    label: 'CHECK_PASSWORD_HISTORY_KEY',
    stateKey: 'check_history',
    isCheckbox: true,
  },
  {
    gridXs: 10,
    label: 'CHECK_PASSWORD_COMPLEXITY_KEY',
    stateKey: 'check_complexity',
    isCheckbox: true,
  },
];
